<template>
  <div class="right-home hq-system-home">
    <div class="breadcrumb">首页</div>
    <div class="right-main">
      <div
        v-if='$hasPermission("crm:admin:store:pendingNum") || $hasPermission("pms:admin:sku:group:statistics") || $hasPermission("oms:admin:order:orderCount") || $hasPermission("crm:admin:complaints:pendingNum") || $hasPermission("epay:admin:warningLine:countStore")'>
        <el-row :gutter="20" style="margin-left:0;margin-right:0;" v-if="pending">
          <!-- <div> -->
          <div class="region">
            <div class="region-title">待处理事务</div>
            <el-row :gutter="20">
              <el-col style="display:flex;justify-content: flex-start;">
                <router-link :to="{ path: '/platformmes', query: { auditStatus: 'PENDING' } }" v-if='$hasPermission("crm:admin:store:pendingNum")' v-permission="['crm:admin:store:pendingNum']"
                  class="region-content" style="flex-direction: column;width: 20%;">
                  <h3 class="region-num">{{ pendingList.platform }}</h3>
                  <span class="region-text" v-if="pendingList.platform !== ''">待审核平台</span>
                </router-link>
                <router-link :to="{ path: '/skulist', query: { auditStatus: 'WAIT_AUDIT' } }" v-if='$hasPermission("pms:admin:sku:group:statistics")' v-permission="'pms:admin:sku:group:statistics'"
                  class="region-content" style="flex-direction: column;width: 20%;">
                  <h3 class="region-num">{{ pendingList.SKUList }}</h3>
                  <span class="region-text">待审核SKU组</span>
                </router-link>
                <router-link :to="{ path: '/order', query: { paymentStatus: 'UNPAID', orderStatus: 'SUBMITTED' } }" v-if='$hasPermission("oms:admin:order:orderCount")'
                  v-permission="'oms:admin:order:orderCount'" class="region-content" style="flex-direction: column;width: 20%;">
                  <h3 class="region-num">{{ pendingList.order }}</h3>
                  <span class="region-text">未支付</span>
                </router-link>
                <router-link :to="{ path: '/complain', query: { handleStatus: 'PENDING' } }" v-if='$hasPermission("crm:admin:complaints:pendingNum")' v-permission="'crm:admin:complaints:pendingNum'"
                  class="region-content" style="flex-direction: column;width: 20%;">
                  <h3 class="region-num">{{ pendingList.complain }}</h3>
                  <span class="region-text" v-if="pendingList.complain !== ''">待处理投诉</span>
                </router-link>
                <router-link :to="{ path: '/epay/vpayAccount', query: { minBalanceLine: true } }" v-if='$hasPermission("epay:admin:warningLine:countStore")'
                  v-permission="'epay:admin:warningLine:countStore'" class="region-content" style="flex-direction: column;width: 20%;">
                  <h3 class="region-num">{{ warningLineCountStore }}</h3>
                  <span class="region-text" v-if="warningLineCountStore !== ''">余额告急平台</span>
                </router-link>
              </el-col>
            </el-row>
          </div>
          <!-- </div> -->
        </el-row>
      </div>
      <el-row :gutter="20" v-if="$hasPermission('epay:admin:stats:workTodo')" v-permission="'epay:admin:stats:workTodo'" style=" margin-left:0;margin-right:0;">
        <div class="region">
          <div class="region-title">问题数据</div>
          <el-row :gutter="20">
            <el-col style="display:flex;justify-content: flex-start;">
              <router-link :to="{ path: '/epay/vpayChargeStats', query: { checked: 'false' } }" v-if='$hasPermission("epay:admin:workTodo:cntUnchecked")'
                v-permission="'epay:admin:workTodo:cntUnchecked'" class="region-content" style="flex-direction: column;width: 33%;">
                <h3 class="region-num">{{ problemData.cntUnchecked }}</h3>
                <span class="region-text" v-if="problemData.cntUnchecked !== ''">收款未校验</span>
              </router-link>
              <router-link :to="{ path: '/epay/vpayChargeStats', query: { checked: 'true', equalZero: 'false' } }" v-if='$hasPermission("epay:admin:workTodo:cntBalancingAccount")'
                v-permission="'epay:admin:workTodo:cntBalancingAccount'" class="region-content" style="flex-direction: column;width: 33%;">
                <h3 class="region-num">{{ problemData.cntBalancingAccount }}</h3>
                <span class="region-text" v-if="problemData.cntBalancingAccount !== ''">收款已校验未平账</span>
              </router-link>
              <router-link :to="{ path: '/epay/vpayCharge', query: { auditStatus: 'APPLY' } }" v-if='$hasPermission("epay:admin:workTodo:cntChargeApply")'
                v-permission="'epay:admin:workTodo:cntChargeApply'" class="region-content" style="flex-direction: column;width: 33%;">
                <h3 class="region-num">{{ problemData.cntChargeApply }}</h3>
                <span class="region-text" v-if="problemData.cntChargeApply !== ''">待审核充值</span>
              </router-link>
            </el-col>
          </el-row>
        </div>
      </el-row>
      <el-row :gutter="20" v-if='$hasPermission("oms:admin:order:storeSpuSaleStatistic")' v-permission="'oms:admin:order:storeSpuSaleStatistic'" style="margin-left:0;margin-right:0;">
        <div class="region">
          <div class="pro-scale">
            <div>销售统计</div>
            <div class="pro-date">
              <el-date-picker v-model="value6" type="daterange" align="left" unlink-panels range-separator="至" start-placeholder="请选择开始日期" end-placeholder="请选择结束日期" :picker-options="pickerOptions">
              </el-date-picker>
              <div> 平台号： <el-autocomplete v-model="storeMsg.storeCode" :fetch-suggestions="querySearchAsync" placeholder="请输入内容" :trigger-on-focus="false" @select="handleSelect"></el-autocomplete>
              </div>
              <el-button @click="getOrderStore('销售统计')" round>查询</el-button>
            </div>
          </div>
          <div id="main" style="width: 100%;height: 300px" ref="mainRef"></div>
        </div>
      </el-row>
      <el-row :gutter="20" v-if='$hasPermission("oms:admin:order:originStatistic")' v-permission="'oms:admin:order:originStatistic'" style="margin-left:0;margin-right:0;">
        <div class="region">
          <div class="pro-scale">
            <div>订单来源</div>
            <div class="pro-date">
              <el-date-picker v-model="value4" type="daterange" align="left" unlink-panels range-separator="至" @change="getOrderOriginStatistic('订单来源')" start-placeholder="请选择开始日期"
                end-placeholder="请选择结束日期" :picker-options="pickerOptions">
              </el-date-picker>
            </div>
          </div>
          <div id="source" style="width: 100%;height:300px;"></div>
        </div>
      </el-row>
      <el-row v-if='$hasPermission("epay:admin:stats:statsVpayCharge")' v-permission="'epay:admin:stats:statsVpayCharge'">
        <el-col>
          <div class="region">
            <div class="pro-scale">
              <div>充值统计</div>
              <div class="pro-date">
                <el-date-picker class="datepicker" v-model="date.date2" type="daterange" align="left" unlink-panels range-separator="至" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                  start-placeholder="请选择开始日期" end-placeholder="请选择结束日期" :picker-options="pickerOptions2">
                </el-date-picker>
                <el-button round @click="onSubmit('充值统计')">查询</el-button>
              </div>
            </div>
            <div id="recharge" style="width: 100%;height: 300px"></div>
          </div>
        </el-col>
      </el-row>
      <el-row v-permission="'epay:admin:stats:statsVpayTrade'" v-if='$hasPermission("epay:admin:stats:statsVpayTrade")'>
        <el-col>
          <div class="region">
            <div class="pro-scale">
              <div>余额消费统计</div>
              <div class="pro-date">
                <el-date-picker v-model="date.date3" type="daterange" align="left" unlink-panels range-separator="至" format="yyyy-MM-dd" value-format="yyyy-MM-dd" start-placeholder="请选择开始日期"
                  end-placeholder="请选择结束日期" :picker-options="pickerOptions2">
                </el-date-picker>
                <el-button round @click="onSubmit('余额消费统计')">查询</el-button>
              </div>
            </div>
            <div id="Balance" style="width: 100%;height: 300px"></div>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if='$hasPermission("oms:admin:order:spuCategorySaleStatistic")'>
        <el-col :span="12" v-permission="'oms:admin:order:spuCategorySaleStatistic'">
          <div class="floatbox">
            <div class="pro-scale">
              <div>产品分类销售情况</div>
              <div style="color: #1473E6 ;font-weight: normal" v-permission="'oms:admin:order:spuSaleStatistic'">总数量： {{ classifySalesTotal }}</div>
              <div>
                <el-date-picker v-model="value2" type="daterange" align="left" unlink-panels range-separator="至" start-placeholder="请选择开始日期" end-placeholder="请选择结束日期"
                  @change="getOrderSpuCategorySaleStatistic('产品分类销售情况')" :picker-options="pickerOptions">
                </el-date-picker>
              </div>
            </div>
            <el-table :data="spuCategorySaledata" :default-sort="{ prop: 'count', order: 'ascending' }" @sort-change='sortChange' height="350" style="width: 100%">
              <el-table-column prop="categoryName" label="分类名称" min-width="180">
              </el-table-column>
              <el-table-column prop="nums" label="销售数量" sortable='custom' min-width="180">
              </el-table-column>
              <el-table-column prop="scale" label="销售比例" min-width="180">
              </el-table-column>
            </el-table>
            <v-pagination class="v-pagination" @changePage="changePage2" :queryInfo="queryInfo2"></v-pagination>
          </div>
        </el-col>
        <el-col :span="12" v-if='$hasPermission("oms:admin:order:paymentTypeStatistic")' v-permission="'oms:admin:order:paymentTypeStatistic'">
          <div class="floatbox">
            <div class="region" style="border:none;">
              <div class="pro-scale">
                <div>订单分析</div>
                <div class="pro-date">
                  <el-date-picker v-model="value5" type="daterange" align="left" unlink-panels range-separator="至" @change="getOrderPaymentTypeStatistic('订单分析')" start-placeholder="请选择开始日期"
                    end-placeholder="请选择结束日期" :picker-options="pickerOptions">
                  </el-date-picker>
                </div>
              </div>
              <div class="analysis-echarts">
                <div id="analysis" style="width:100%;height:394px;"></div>
                <div class="analysis-list">
                  <ul>
                    <li v-for="(  item, index  ) in   analysisData  " :key="index">
                      <span class="a-name">{{ item.name }}</span>
                      <span class="a-value">{{ item.value }}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="12" v-if='$hasPermission("oms:admin:order:spuSaleStatistic")' v-permission="'oms:admin:order:spuSaleStatistic'">
          <div class="floatbox">
            <div class="pro-scale">
              <div>产品销售情况</div>
              <div style="color: #1473E6 ;font-weight: normal" v-permission="'oms:admin:order:spuSaleStatistic'">总数量： {{ salesTotal }}</div>
              <div>
                <el-date-picker v-model="value3" type="daterange" align="left" unlink-panels range-separator="至" @change="getOrderSpuSaleStatistic('产品销售情况')" start-placeholder="请选择开始日期"
                  end-placeholder="请选择结束日期" :picker-options="pickerOptions">
                </el-date-picker>
              </div>
            </div>
            <el-table :data="proSalesData" height="400px" :default-sort="{ prop: 'count', order: 'ascending' }" @sort-change='sort2Change' style="width: 100%">
              <el-table-column prop="spuName" label="产品名称">
              </el-table-column>
              <el-table-column prop="categoryName" label="产品类">
              </el-table-column>
              <el-table-column prop="nums" sortable label="销售数量">
              </el-table-column>
              <el-table-column prop="ratio" label="销售比例">
              </el-table-column>
            </el-table>
            <v-pagination class="v-pagination" @changePage="changePage3" :queryInfo="queryInfo3"></v-pagination>
          </div>
        </el-col>
        <el-col :span="12" v-if='$hasPermission("oms:admin:order:quantityStatistic")' v-permission="'oms:admin:order:quantityStatistic'">
          <div class="floatbox">
            <div class="region" style="border:none;height:">
              <div class="region-title"> 订单数统计 <el-date-picker v-model="value1" type="daterange" align="right" :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期"
                  class="orderNum" @change="getOrderQuantityStatisticPage('订单数统计')" end-placeholder="结束日期">
                </el-date-picker>
              </div>
              <el-table :data="orderNumData" height="406px" style="width: 100%">
                <el-table-column prop="date" label="日期">
                </el-table-column>
                <el-table-column prop="nums" label="订单总数">
                </el-table-column>
              </el-table>
              <v-pagination class="v-pagination" @changePage="changePage1" :queryInfo="queryInfo1"></v-pagination>
            </div>
          </div>
        </el-col>
        <el-col :span="12" v-if='$hasPermission("epay:admin:stats:statsOnline")' v-permission="'epay:admin:stats:statsOnline'">
          <div class="region" style="border: 1px solid #ececec;">
            <div class="pro-scale">
              <div>移动支付统计</div>
              <div class="pro-date">
                <el-date-picker v-model="date.date4" type="daterange" align="left" unlink-panels range-separator="至" format="yyyy-MM-dd" value-format="yyyy-MM-dd" start-placeholder="请选择开始日期"
                  end-placeholder="请选择结束日期" :picker-options="pickerOptions2">
                </el-date-picker>
                <el-button round @click="onSubmit('移动支付统计')">查询</el-button>
              </div>
            </div>
            <el-table :data="tableData2" border height="411px" show-summary>
              <el-table-column prop="datePayment" label="日期">
              </el-table-column>
              <el-table-column prop="amountAlipay" label="支付宝">
              </el-table-column>
              <el-table-column prop="amountWxpay" label="微信">
              </el-table-column>
              <el-table-column prop="amountTotal" label="合计">
              </el-table-column>
            </el-table>
            <v-pagination class="v-pagination" @changePage="changePage5" :queryInfo="queryInfo5"></v-pagination>
          </div>
        </el-col>
        <el-col :span="12" v-if='$hasPermission("epay:admin:stats:analysisVpay")' v-permission="'epay:admin:stats:analysisVpay'">
          <div class="region" style="height: 536px;border: 1px solid #ececec;">
            <div class="region-title">
              <span>交易分析</span>
              <el-date-picker class="datepicker" v-model="date.date1" type="daterange" align="left" unlink-panels range-separator="至" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                start-placeholder="请选择开始日期" end-placeholder="请选择结束日期" :picker-options="pickerOptions2">
              </el-date-picker>
              <el-button round @click="onSubmit('交易分析')">查询</el-button>
            </div>
            <el-table height="416px" show-summary :data="tableData1">
              <el-table-column prop="datePayment" label="日期">
              </el-table-column>
              <el-table-column prop="amountCharge" label="充值金额">
              </el-table-column>
              <el-table-column prop="amountTrade" label="余额消费">
              </el-table-column>
              <el-table-column prop="accountBalance" label="余额剩余">
              </el-table-column>
              <el-table-column prop="bonusBalance" label="虚拟充值剩余">
              </el-table-column>
            </el-table>
            <v-pagination class="v-pagination" @changePage="changePage4" :queryInfo="queryInfo4"></v-pagination>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import moneyImg from '@/assets/images/money.svg'
import codeImg from '@/assets/images/code.svg'
import VPagination from '@/components/Pagination/index'
import { storeGetStoreList, storeGetPendingNum, complaintsGetComplaintsList, storeQueryListByCode, complaintsGetPendingNum } from '@/api/crm'
import { skuGroupCounter } from '@/api/pms'
import { order, orderCount, orderStore, orderQuantityStatisticPage, orderPaymentTypeStatistic, orderOriginStatistic, orderSpuSaleStatistic, orderQuantityStatistic, orderSpuSaleCountStatistic, orderSpuCategorySaleStatistic } from '@/api/oms'
import { statsAnalysisVpay, statsStatsOnline, statsWorkTodo, statsVpayCharge, statsVpayTrade, warningLineCountStore } from '@/api/epay'
export default {
  name: 'hq-system-home',
  components: { VPagination },
  data () {
    return {
      pending: true,
      warningLineCountStore: '',
      Balance: [],
      recharge: [],
      storeMsg: {
        storeId: null,
        storeCode: ''
      },
      EchartsLineData: [],
      EchartsSource: {},
      classifySalesTotal: 0,
      salesTotal: 0,
      orderNumData: [],
      pendingList: {
        platform: '',
        SKUList: '',
        order: '',
        complain: ''
      },
      moneyImg: moneyImg,
      codeImg: codeImg,
      spuCategorySaledata: [],
      proSalesData: [],
      channels: [],
      value1: [this.$moment(new Date().getTime() - 3600 * 1000 * 24 * 7).format('YYYY-MM-DD') + ' 00:00:00', this.$moment(new Date()).format('YYYY-MM-DD') + ' 00:00:00'],
      value2: [this.$moment(new Date().getTime() - 3600 * 1000 * 24 * 7).format('YYYY-MM-DD') + ' 00:00:00', this.$moment(new Date()).format('YYYY-MM-DD') + ' 00:00:00'],
      value3: [this.$moment(new Date().getTime() - 3600 * 1000 * 24 * 7).format('YYYY-MM-DD') + ' 00:00:00', this.$moment(new Date()).format('YYYY-MM-DD') + ' 00:00:00'],
      value4: [this.$moment(new Date().getTime() - 3600 * 1000 * 24 * 7).format('YYYY-MM-DD') + ' 00:00:00', this.$moment(new Date()).format('YYYY-MM-DD') + ' 00:00:00'],
      value5: [this.$moment(new Date().getTime() - 3600 * 1000 * 24 * 7).format('YYYY-MM-DD') + ' 00:00:00', this.$moment(new Date()).format('YYYY-MM-DD') + ' 00:00:00'],
      value6: [this.$moment(new Date().getTime() - 3600 * 1000 * 24 * 7).format('YYYY-MM-DD') + ' 00:00:00', this.$moment(new Date()).format('YYYY-MM-DD') + ' 00:00:00'],
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() > Date.now() - 8.64e6 || time.getTime() < Date.now() - 1000 * 60 * 60 * 24 * 365 - 8.64e6
        },
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      storeId: '',
      analysisData: [],
      queryInfo1: {
        pageNum: 1, // 当前显示第几页
        pageSize: 7, // 每一页显示条数
        total: 0
      },
      queryInfo2: {
        pageNum: 1, // 当前显示第几页
        pageSize: 6, // 每一页显示条数
        total: 0
      },
      queryInfo3: {
        pageNum: 1, // 当前显示第几页
        pageSize: 7, // 每一页显示条数
        total: 0
      },
      sort1: '',
      sort2: '',
      main: [],
      main2: [],
      value: '',
      tableData1: [],
      tableData2: [],
      problemData: {
        cntChargeApply: null,
        cntBalancingAccount: null,
        cntUnchecked: null
      },
      date: {
        date1: [this.$moment(new Date().getTime() - 3600 * 1000 * 24 * 7).format('YYYY-MM-DD') + ' 00:00:00', this.$moment(new Date()).format('YYYY-MM-DD') + ' 00:00:00'],
        date2: [this.$moment(new Date().getTime() - 3600 * 1000 * 24 * 7).format('YYYY-MM-DD') + ' 00:00:00', this.$moment(new Date()).format('YYYY-MM-DD') + ' 00:00:00'],
        date3: [this.$moment(new Date().getTime() - 3600 * 1000 * 24 * 7).format('YYYY-MM-DD') + ' 00:00:00', this.$moment(new Date()).format('YYYY-MM-DD') + ' 00:00:00'],
        date4: [this.$moment(new Date().getTime() - 3600 * 1000 * 24 * 7).format('YYYY-MM-DD') + ' 00:00:00', this.$moment(new Date()).format('YYYY-MM-DD') + ' 00:00:00']
      },
      pickerOptions2: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6
        },
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      queryInfo4: {
        pageNum: 1, // 当前显示第几页
        pageSize: 4, // 每一页显示条数
        total: 0
      },
      queryInfo5: {
        pageNum: 1, // 当前显示第几页
        pageSize: 4, // 每一页显示条数
        total: 0
      }
    }
  },
  created () {
    console.log('判断登录, 未成功登录不执行下列方法')
    console.log(!this.$store.state.user.isLogin)
    if (!this.$store.state.user.isLogin) return
    if (
      !this.$hasPermission('crm:admin:store:pendingNum') &&
      !this.$hasPermission('pms:admin:sku:group:statistics') &&
      !this.$hasPermission('oms:admin:order:orderCount') &&
      !this.$hasPermission('crm:admin:complaints:pendingNum') &&
      !this.$hasPermission('epay:admin:warningLine:countStore')
    ) {
      this.pending = false
    }
    this.$hasPermission('epay:admin:warningLine:countStore') && this.getWarningLineCountStore()
    this.searchPlateform()
    this.$hasPermission('oms:admin:order:quantityStatistic') && this.getOrderQuantityStatisticPage()
    this.$hasPermission('oms:admin:order:spuCategorySaleStatistic') && this.getOrderSpuCategorySaleStatistic()
    this.$hasPermission('oms:admin:order:spuSaleStatistic') && this.getOrderSpuSaleStatistic()
    console.log(this.$hasPermission('epay:admin:stats:analysisVpay'))
    if (this.$hasPermission('epay:admin:stats:analysisVpay')) {
      this.onSubmit('交易分析')
    }
    if (this.$hasPermission('epay:admin:stats:workTodo')) {
      this.onSubmit('问题数据')
    }
    if (this.$hasPermission('epay:admin:stats:statsOnline')) {
      this.onSubmit('移动支付统计')
    }
  },
  mounted () {
    if (!this.$store.state.user.isLogin) return
    console.log(this.$hasPermission('epay:admin:stats:analysisVpay'))
    this.$hasPermission('oms:admin:order:originStatistic') && this.getOrderOriginStatistic()
    this.$hasPermission('oms:admin:order:paymentTypeStatistic') && this.getOrderPaymentTypeStatistic()
    this.$hasPermission('oms:admin:order:storeSpuSaleStatistic') && this.getOrderStore()
    if (this.$hasPermission('epay:admin:stats:statsVpayCharge')) {
      this.onSubmit('充值统计')
    }
    if (this.$hasPermission('epay:admin:stats:statsVpayTrade')) {
      this.onSubmit('余额消费统计')
    }
  },
  methods: {
    getWarningLineCountStore () {
      warningLineCountStore().then(res => {
        console.log(res.data.data)
        this.warningLineCountStore = res.data.data.count
        // console.log(res.data.data.count, this.warningLineCountStore)
      })
    },
    sort2Change (val) {
      if (val.order === 'descending') this.sort2 = 'nums,desc'
      if (val.order === 'ascending') this.sort2 = 'nums,asc'
      if (val.order === null) this.sort2 = ''
      this.getOrderSpuSaleStatistic()
    },
    sortChange (val) {
      this.sort1 = val.order === 'descending' && 'nums,desc'
      if (val.order === 'ascending') this.sort1 = 'nums,asc'
      if (val.order === null) this.sort1 = ''
      this.getOrderSpuCategorySaleStatistic()
    },
    // 订单数统计
    getOrderQuantityStatisticPage () {
      orderQuantityStatisticPage({
        startDate: this.$moment(this.value1[0]).format('YYYY-MM-DD') + ' 00:00:00',
        endDate: this.$moment(this.value1[1]).add(1, 'days').format('YYYY-MM-DD') + ' 00:00:00',
        page: this.queryInfo1.pageNum - 1,
        size: this.queryInfo1.pageSize
      }).then(res => {
        if (res.data.success) {
          this.orderNumData = res.data.data.content
          this.queryInfo1.total = res.data.data.total
        }
      })
    },
    // 产品分类销售情况
    getOrderSpuCategorySaleStatistic () {
      if (this.$hasPermission('oms:admin:order:spuSaleStatistic')) {
        // 总数量
        orderSpuSaleCountStatistic({
          startDate: this.$moment(this.value2[0]).format('YYYY-MM-DD') + ' 00:00:00',
          endDate: this.$moment(this.value2[1]).add(1, 'days').format('YYYY-MM-DD') + ' 00:00:00'
        }).then(res => {
          if (res.data.success) {
            this.classifySalesTotal = res.data.success ? res.data.data : 0
            console.log(res.data.data)
            orderSpuCategorySaleStatistic({
              startDate: this.$moment(this.value2[0]).format('YYYY-MM-DD') + ' 00:00:00',
              endDate: this.$moment(this.value2[1]).add(1, 'days').format('YYYY-MM-DD') + ' 00:00:00',
              page: this.queryInfo2.pageNum - 1,
              size: this.queryInfo2.pageSize,
              sort: this.sort1 ? this.sort1 : null
            }).then(res => {
              if (!res.data.success) {
                return
              }
              this.queryInfo2.total = res.data.data.total
              this.spuCategorySaledata = res.data.data.content
              console.log(res.data.data.content)
              this.spuCategorySaledata.forEach(item => {
                this.$set(item, 'scale', Math.floor((item.nums / this.classifySalesTotal * 100) * 100) / 100 + '%')
              })
              console.log(this.spuCategorySaledata.scale)
            })
          }
        })
      }
    },
    // 产品销售情况
    getOrderSpuSaleStatistic () {
      if (this.$hasPermission('oms:admin:order:spuSaleStatistic')) {
        // 总数量
        orderSpuSaleCountStatistic({
          channels: 'B2B',
          startDate: this.$moment(this.value3[0]).format('YYYY-MM-DD') + ' 00:00:00',
          endDate: this.$moment(this.value3[1]).add(1, 'days').format('YYYY-MM-DD') + ' 00:00:00'
        }).then(res => {
          if (res.data.success) {
            this.salesTotal = res.data.success ? res.data.data : 0
            console.log(res.data.success, res.data.data)
            orderSpuSaleStatistic({
              channel: 'B2B',
              startDate: this.$moment(this.value3[0]).format('YYYY-MM-DD') + ' 00:00:00',
              endDate: this.$moment(this.value3[1]).add(1, 'days').format('YYYY-MM-DD') + ' 00:00:00',
              page: this.queryInfo3.pageNum - 1,
              size: this.queryInfo3.pageSize,
              sort: this.sort2
            }).then(res => {
              if (!res.data.success) {
                return
              }
              this.queryInfo3.total = res.data.data.total
              let list = res.data.data.content
              list.forEach(item => {
                item.ratio = Math.floor((item.nums / this.salesTotal * 100) * 100) / 100 + '%'
              })
              this.proSalesData = list
              console.log(this.proSalesData)
            })
          }
        })
      }
    },
    // 订单来源
    getOrderOriginStatistic () {
      orderOriginStatistic({
        startDate: this.$moment(this.value4[0]).format('YYYY-MM-DD') + ' 00:00:00',
        endDate: this.$moment(this.value4[1]).add(1, 'days').format('YYYY-MM-DD') + ' 00:00:00'
      }).then(res => {
        console.log(res)
        let i = 0
        this.EchartsSource = { legendData: [], xAxisData: [], series: [] }
        res.data.data.forEach(item => {
          this.EchartsSource.legendData.push(item.originType)
        })
        console.log(res.data.data)
        while (1) {
          let a = this.$moment(this.value4[0]).add(i, 'd').format('MM-DD ddd')
          this.EchartsSource.xAxisData.push(a)
          i++
          if (a === this.$moment(this.value4[1]).format('MM-DD ddd')) break
        }
        this.EchartsSource.legendData = Array.from(new Set(this.EchartsSource.legendData))
        this.EchartsSource.xAxisData = Array.from(new Set(this.EchartsSource.xAxisData))
        // this.EchartsSource.xAxisData.reverse()
        this.EchartsSource.legendData.forEach(item => {
          this.EchartsSource.series.push({
            name: item,
            type: 'line',
            data: new Array(this.EchartsSource.xAxisData.length).fill(0)
          })
        })
        res.data.data.forEach(item => {
          this.EchartsSource.series.forEach(val => {
            if (val.name === item.originType) {
              val.data[this.EchartsSource.xAxisData.indexOf(this.$moment(item.date).format('MM-DD ddd'))] = item.nums
            }
          })
        })
        this.getEchartsSource()
      })
    },
    // 订单分析
    getOrderPaymentTypeStatistic () {
      orderPaymentTypeStatistic({
        startDate: this.$moment(this.value5[0]).format('YYYY-MM-DD') + ' 00:00:00',
        endDate: this.$moment(this.value5[1]).add(1, 'days').format('YYYY-MM-DD') + ' 00:00:00'
      }).then(res => {
        this.analysisData = []
        res.data.data.forEach(item => {
          console.log(res.data.data)
          if (this.$config.payType[item.paymentType]) item.paymentType = this.$config.payType[item.paymentType]
          if (!item.paymentType && item.paymentStatus === 'UNPAID') item.paymentType = '未支付'
          // if (item.paymentType === 'VPAY') item.paymentType = '余额支付'
          // if (item.paymentType === 'WXPAY') item.paymentType = '微信支付'
          // if (item.paymentType === 'ALIPAY') item.paymentType = '支付宝'

          this.analysisData.push({ name: item.paymentType, value: item.nums })
        })
        console.log(res.data.data)
        this.getEchartsAnalysis()
      })
    },
    // 销售统计
    getOrderStore () {
      orderStore({
        params: {
          startDate: this.$moment(this.value6[0]).format('YYYY-MM-DD') + ' 00:00:00',
          endDate: this.$moment(this.value6[1]).add(1, 'days').format('YYYY-MM-DD') + ' 00:00:00',
          storeId: this.storeMsg.storeId
        }
      }).then(res => {
        console.log(res.data.data)
        let arr = []
        res.data.data.forEach(item => {
          arr.push([item.date, item.nums])
        })
        this.EchartsLineData = arr
        this.getEcharts()
      })
    },
    searchPlateform (val) {
      if (this.$hasPermission('crm:admin:store:pendingNum')) {
        // 待审核平台
        storeGetPendingNum({ pageNum: 1, pageSize: -1, storVo: { auditStatus: 'PENDING' } }).then((res) => {
          if (res.data.success) {
            this.pendingList.platform = res.data.data
          }
        })
      }
      if (this.$hasPermission('pms:admin:sku:group:statistics')) {
        // 待审核sku组
        skuGroupCounter('WAIT_AUDIT').then((res) => {
          if (res.data.success) {
            this.pendingList.SKUList = res.data.data
          } else {
          }
        })
      }
      if (this.$hasPermission('oms:admin:order:orderCount')) {
        // 未支付
        orderCount({ paymentStatus: 'UNPAID', channels: ' ' }).then((res) => {
          this.pendingList.order = res.data.data
        })
      }
      if (this.$hasPermission('crm:admin:complaints:pendingNum')) {
        // 待处理投诉
        complaintsGetPendingNum().then((res) => {
          if (res.data.success) {
            this.pendingList.complain = res.data.data
          } else {
          }
        })
      }
    },
    getEcharts () {
      const echarts = require('echarts')
      const myChart = echarts.init(document.getElementById('main'))
      myChart.setOption({
        tooltip: {
          trigger: 'axis', // 坐标轴触发，主要在柱状图，折线图等会使用类目轴的图表中使用
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'line' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false
        },
        yAxis: {
          type: 'value',
          boundaryGap: [0, '50%']
        },
        visualMap: {
          type: 'piecewise',
          show: false,
          dimension: 0,
          seriesIndex: 0,
          pieces: [{
            gt: 0,
            lt: 100,
            color: '#dbeefc'
          }]
        },
        series: [
          {
            type: 'line',
            smooth: 0.5,
            symbol: 'none',
            lineStyle: {
              color: '#68b7f0',
              width: 3
            },
            markLine: {
              symbol: ['none', 'none'],
              label: { show: false },
              data: []
            },
            areaStyle: {},
            data: this.EchartsLineData
          }
        ]
      })
      window.addEventListener('resize', function () {
        myChart.resize()
      })
    },
    getEchartsSource () {
      const echarts = require('echarts')
      const myChart = echarts.init(document.getElementById('source'))
      myChart.setOption({
        title: {
          text: ''
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: this.EchartsSource.legendData,
          right: 20,
          top: 10
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        toolbox: {
          feature: {
            // saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.EchartsSource.xAxisData
        },
        yAxis: {
          type: 'value'
        },
        series: this.EchartsSource.series
      }
      )
      window.addEventListener('resize', function () {
        myChart.resize()
      })
    },
    getEchartsAnalysis () {
      const echarts = require('echarts')
      let _this = this
      const myChart = echarts.init(document.getElementById('analysis'))
      myChart.setOption({
        title: {
          text: '',
          subtext: '',
          left: ''
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          // orient: 'vertical',
          left: 'left',
          data: ['余额支付', '微信支付', '支付宝支付'],
          top: 10
        },
        color: ['#d7d7d7', '#1aad19', '#1576ff'],
        series: [
          {
            name: '',
            type: 'pie',
            radius: '55%',
            center: ['50%', '60%'],
            data: _this.analysisData,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      })
      window.addEventListener('resize', function () {
        myChart.resize()
      })
    },
    handleSelect (item) {
      this.storeMsg.storeId = item.id
    },
    querySearchAsync (queryString, cb) {
      storeQueryListByCode(queryString).then(res => {
        res.data.data.forEach(item => {
          item.value = item.code
        })
        cb(res.data.data)
      })
    },
    changePage1 (val) {
      this.queryInfo1 = val
      this.getOrderQuantityStatisticPage()
    },
    changePage2 (val) {
      this.queryInfo2 = val
      this.getOrderSpuCategorySaleStatistic()
    },
    changePage3 (val) {
      this.queryInfo3 = val
      this.getOrderSpuSaleStatistic()
    },
    onSubmit (val) {
      if (val === '交易分析') {
        statsAnalysisVpay({
          dateEnd: this.$moment(this.date.date1[1]).format('YYYY-MM-DD'),
          dateStart: this.$moment(this.date.date1[0]).format('YYYY-MM-DD')
        }).then(res => {
          this.tableData1 = res.data.data
        })
      } else if (val === '问题数据') {
        statsWorkTodo({ dateEnd: this.$moment(new Date()).format('YYYY-MM-DD'), dateStart: '2020-09-07' }).then(res => {
          this.problemData = res.data.data
          console.log(this.problemData)
        })
      } else if (val === '移动支付统计') {
        statsStatsOnline({
          dateEnd: this.$moment(this.date.date4[1]).format('YYYY-MM-DD'),
          dateStart: this.$moment(this.date.date4[0]).format('YYYY-MM-DD')
        }).then(res => {
          this.tableData2 = res.data.data
        })
      } else if (val === '充值统计') {
        statsVpayCharge({
          dateEnd: this.$moment(this.date.date2[1]).format('YYYY-MM-DD'),
          dateStart: this.$moment(this.date.date2[0]).format('YYYY-MM-DD')
        }).then(res => {
          console.log('充值统计', res.data.data)
          let arr = []
          res.data.data.forEach(item => {
            arr.push([item.datePayment, item.amountPreDay])
          })
          console.log(res.data.data)
          arr.reverse()
          this.recharge = arr
          this.getEachrs()
        })
      } else if (val === '余额消费统计') {
        statsAnalysisVpay({
          dateEnd: this.$moment(this.date.date3[1]).format('YYYY-MM-DD'),
          dateStart: this.$moment(this.date.date3[0]).format('YYYY-MM-DD')
        }).then(res => {
          console.log(res.data.data)
          let arr = []
          res.data.data.forEach(item => {
            arr.push([item.datePayment, item.amountTrade])
          })
          console.log(res.data.data)
          arr.reverse()
          this.Balance = arr
          console.log('this.Balance', this.Balance)
          this.getEachrs2()
        })
      }
    },
    getEachrs () {
      const echarts = require('echarts')
      const myChart = echarts.init(document.getElementById('recharge'))
      myChart.setOption({
        tooltip: {
          trigger: 'axis', // 坐标轴触发，主要在柱状图，折线图等会使用类目轴的图表中使用
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'line' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        xAxis: {
          type: 'category', // 坐标轴类型 category：类目轴
          boundaryGap: false// 坐标轴两边留白
        },
        yAxis: {
          type: 'value',
          boundaryGap: [0, '50%']
        },
        visualMap: { // 视觉映射组件
          type: 'piecewise', // 分段型视觉映射组件
          show: false, // 是否显示visualMap-piecewise 组件。
          dimension: 0, // 维度
          seriesIndex: 0,
          pieces: [{ // 自定义范围
            gt: 0, // 大于
            lt: 100, // 小于
            color: '#dbeefc'
          }]
        },
        series: [
          {
            type: 'line',
            smooth: 0.5, // 是否平滑视觉引导线
            symbol: 'none', // 标记的图形
            lineStyle: {
              color: '#68b7f0',
              width: 3
            },
            markLine: { // 图表标线
              symbol: ['none', 'none'],
              label: { show: false },
              data: []
            },
            areaStyle: {},
            data: this.recharge
          }
        ]
      })
    },
    getEachrs2 () {
      const echarts = require('echarts')
      const myChart = echarts.init(document.getElementById('Balance'))
      myChart.setOption({
        tooltip: {
          trigger: 'axis', // 坐标轴触发，主要在柱状图，折线图等会使用类目轴的图表中使用
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'line' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        xAxis: {
          type: 'category', // 坐标轴类型 category：类目轴
          boundaryGap: false// 坐标轴两边留白
        },
        yAxis: {
          type: 'value',
          boundaryGap: [0, '50%']
        },
        visualMap: { // 视觉映射组件
          type: 'piecewise', // 分段型视觉映射组件
          show: false, // 是否显示visualMap-piecewise 组件。
          dimension: 0, // 维度
          seriesIndex: 0,
          pieces: [{ // 自定义范围
            gt: 0, // 大于
            lt: 100, // 小于
            color: '#dbeefc'
          }]
        },
        series: [
          {
            type: 'line',
            smooth: 0.5, // 是否平滑视觉引导线
            symbol: 'none', // 标记的图形
            lineStyle: {
              color: '#68b7f0',
              width: 3
            },
            markLine: { // 图表标线
              symbol: ['none', 'none'],
              label: { show: false },
              data: []
            },
            areaStyle: {},
            data: this.Balance
          }
        ]
      })
    },
    changePage4 (val) {
      this.queryInfo4 = val
      // this.getOrderList('交易分析')
    },
    changePage5 (val) {
      this.queryInfo5 = val
      // this.getOrderList('移动支付统计')
    }
  }
}
</script>
<style scoped lang="less">
@deep: ~'>>>';
@import 'styles.less';

.orderNum {
  width: 330px !important;
  height: 30px;

  // background: red;
  @{deep}.el-range__icon {
    line-height: 23px !important;
  }

  @{deep}.el-range-separator {
    line-height: 23px !important;
  }
}

.floatbox {
  // width: 49.5%;
  height: 526px;
  margin-bottom: 10px;
  border: 1px solid #e4e4e4;
}
</style>
